export const CredentialStatus = {
  All: "All",
  Available: "AVAILABLE",
  Deployed: "DEPLOYED",
  Assigned: "ASSIGNED",
  DeliveryFailed: "DELIVERY FAILED",
};
